import { useCustomQuery, useFindByQuery } from '../../graphql';
import { useState, useEffect } from 'react';

export interface Account {
  id: string;
  name: string;
}

const GET_WORKSPACEUSERS = `
  query LindWorkspaceUsers($workspaceId: String) {
  account {
    listWorkspaceUsers(workspaceId: $workspaceId) {
      items {
        id
        name {
          first
          last
        }
      }
    }
  }
}
`;

export const useWorkspaceUsers = (
  workspaceId: string | undefined
): Account[] => {
  const [workspaceUsers, setWorkspaceUsers] = useState<Account[]>([]);

  const { data } = useCustomQuery({
    query: GET_WORKSPACEUSERS,
    variables: { workspaceId: workspaceId === '' ? null : workspaceId }, // Pass null for workspace-less
    cacheKey: ['listWorkspaceUsers', workspaceId],
    options: {
      enabled: workspaceId !== undefined && workspaceId !== null,
    },
  });

  const getDisplayName = (a: any) => {
    return a.name
      ? `${a.name.first || ''} ${a.name.last || ''}`.trim() || a.email || a.id
      : a.email || a.id;
  };

  useEffect(() => {
    const items = data?.account?.listWorkspaceUsers?.items;
    if (!items) {
      setWorkspaceUsers([]);
      return;
    }
    setWorkspaceUsers(
      items.map((a: any) => ({
        id: a.id,
        name: getDisplayName(a),
      }))
    );
  }, [workspaceId, data]);

  return workspaceUsers;
};
